/**
 * @copyright Schweizerische Bundesbahnen SBB
 * @class FormControlDefinition
 * @version 0.0.1
 * @since April 2018
 * @description form model
 */
export class FormModel {
  form_id: string;
  form_name: string;
  form_fields: Array<any>;
}
